
import {module} from '../app';

module.config(function ($httpProvider) {
    $httpProvider.interceptors.push('timeoutHttpIntercept');
  })
  .factory('timeoutHttpIntercept', ['globalHttpTimeout', function (globalHttpTimeout) {
    return {
      'request': function (config) {
        if (!config.timeout) {
          config.timeout = globalHttpTimeout;
        }
        return config;
      }
    };
  }]);



// WEBPACK FOOTER //
// ./src/scripts/services/timeoutHttpIntercept.js